import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../contexts/AuthContext';
import { getCreditBalance } from '../../services/creditService';

const ProtectedRoute: React.FC = () => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Get user's plan status
  const { data: creditBalance, isLoading: isLoadingBalance } = useQuery({
    queryKey: ['creditBalance'],
    queryFn: getCreditBalance,
    enabled: !!user, // Only run if user is authenticated
  });

  useEffect(() => {
    console.log('ProtectedRoute - Auth state:', { user: user ? 'Authenticated' : 'Not authenticated', loading });
  }, [user, loading]);

  if (loading || isLoadingBalance) {
    console.log('ProtectedRoute - Loading auth state...');
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-500"></div>
      </div>
    );
  }

  if (!user) {
    console.log('ProtectedRoute - No user found, redirecting to login');
    return <Navigate to="/auth/login" replace />;
  }

  // Check if user has an active plan
  const hasActivePlan = creditBalance?.plan_credits?.current_plan &&
                       creditBalance.plan_credits.current_plan !== 'free';

  // Pages that don't require a plan
  const planNotRequiredPaths = ['/dashboard/billing', '/dashboard/settings'];
  const isOnPlanNotRequiredPage = planNotRequiredPaths.some(path =>
    location.pathname.startsWith(path)
  );

  // If user doesn't have a plan and is not on billing page, redirect to billing
  if (!hasActivePlan && !isOnPlanNotRequiredPage) {
    console.log('ProtectedRoute - No active plan, redirecting to billing');
    return <Navigate to="/dashboard/billing" replace />;
  }

  console.log('ProtectedRoute - User authenticated with plan, rendering protected content');
  return <Outlet />;
};

export default ProtectedRoute;
